/**
 * 添加多级路径
 *
 * @param {*} url
 */
export const addContentPath = (url) => {
  const ecologyContentPath = window.ecologyContentPath;
  if (url && ecologyContentPath) {
    if (url.startsWith('/') && !url.startsWith(ecologyContentPath)) {
      url = ecologyContentPath + url;
    }
  }
  if (url == ecologyContentPath) {
    url = '';
  }
  return url;
};

/**
 * 添加多级路径
 *
 * @param {*} html
 */
export const addContentPathForHtml = (html, withSrc) => {
  const ecologyContentPath = window.ecologyContentPath;
  if (html && typeof html == 'string' && ecologyContentPath) {
    html = html.replace(new RegExp(ecologyContentPath, 'gm'), '');
    html = html.replace(/url\(('|")?(\/.*?)('|")?\)/g, `url(${ecologyContentPath}$2)`);
    if (withSrc) {
      html = html.replace(/src=('|")(\/.*?)('|")/g, `src='${ecologyContentPath}$2'`);
    }
  }
  return html;
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4coms/util/pathUtil.js